<template>
  <slot v-bind="{ showForm, openForm, closeForm }"></slot>
</template>

<script>
export default {
  data() {
    return {
      showForm: false
    };
  },
  computed: {},
  methods: {
    openForm(fileId) {
      this.showForm = true;
      this.$el.parentNode.querySelector('[name="file_id"]').value = fileId;
    },
    closeForm() {
      this.showForm = false;
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped></style>
